// client/src/utils/axiosConfig.js
import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
  withCredentials: true
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    // /auth/me is polled silently on every page load to check session state,
    // so a 401 there just means "not logged in" — not a session that needs
    // recovering. Redirecting on it would loop: redirect -> reload -> /auth/me -> 401 -> redirect.
    // /auth/login and /auth/signup also return 401/400 on bad credentials —
    // that's a form error the page needs to display, not an expired session,
    // so a hard redirect there would wipe the form and the error message
    // before the user ever sees why the attempt failed.
    const url = error.config?.url || '';
    const isAuthEndpoint = url.includes('/auth/me') || url.includes('/auth/login') || url.includes('/auth/signup');
    if (error.response?.status === 401 && !isAuthEndpoint) {
      localStorage.removeItem('isAuthenticated');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default instance;